import React from 'react';
import "./CSS/Footer.css";

function Footer() {
  return (
    <div className="Footer">
      <p className="footer-message">Built with 🧡 for students, communities, and fridge space everywhere.</p>
      <p className="footer-copyright">© 2025 ShelfAware. All rights reserved.</p>
    </div>
  );
}

export default Footer;

